import React from 'react';
import { Clock, Shield, Wrench, Award, Users, Zap } from 'lucide-react';

export const Differentials = () => {
  const differentials = [
    {
      icon: Clock,
      title: 'Experiência no Setor',
      description: 'Mais de 10 anos de atuação no mercado de climatização comercial e industrial.',
    },
    {
      icon: Users,
      title: 'Atendimento Técnico',
      description: 'Equipe de profissionais qualificados e treinados para oferecer suporte especializado.',
    },
    {
      icon: Wrench,
      title: 'Soluções Sob Medida',
      description: 'Projetos desenvolvidos de acordo com as necessidades específicas de cada cliente.',
    },
    {
      icon: Shield,
      title: 'Confiabilidade',
      description: 'Compromisso com prazos, qualidade na execução e transparência em todas as etapas.',
    },
    {
      icon: Award,
      title: 'Conformidade PMOC',
      description: 'Serviços em conformidade com a legislação vigente de manutenção e qualidade do ar.',
    },
    {
      icon: Zap,
      title: 'Eficiência Energética',
      description: 'Foco em sistemas que proporcionam economia de energia e sustentabilidade.',
    },
  ];

  return (
    <section
      data-testid="differentials-section"
      className="py-20 lg:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-testid="differentials-header">
          <span className="font-manrope text-sm font-bold tracking-[0.2em] uppercase text-sky-600">
            Por Que Escolher a Tokefrio
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 mt-4 mb-6">
            Nossos Diferenciais
          </h2>
          <div className="section-divider mx-auto mb-6"></div>
          <p className="font-manrope text-base sm:text-lg text-slate-600 leading-relaxed">
            Combinamos experiência técnica, atendimento personalizado e compromisso 
            com a qualidade para entregar as melhores soluções em climatização.
          </p>
        </div>

        {/* Differentials Grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="differentials-grid"
        >
          {differentials.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-slate-100 p-6 lg:p-8 hover:shadow-lg transition-all duration-300 card-hover"
              data-testid={`differential-card-${index}`}
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center mb-5">
                <item.icon className="w-6 h-6 text-sky-600" strokeWidth={1.5} />
              </div>

              {/* Title */}
              <h3 className="font-outfit text-lg font-semibold text-slate-800 mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="font-manrope text-sm text-slate-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
